import type { ProcedureCodeFormRow } from "@/pages/app/provider/billings/billing-types";
import {
  Address,
  PatientProcedureCodeDiscountTypeEnum,
  SuperBillPlaceOfServiceEnum,
} from "../../../../services";
type ServiceDetails = {
  uuid: string;
  providerId?: { [key: string]: string };
  locationId?: { [key: string]: string };
  placeOfService?: SuperBillPlaceOfServiceEnum | undefined;
  dateOfService: string | undefined;
  serviceState: string | undefined;
  // ECRH-5370: Billing Address resolved from the selected Service Location, or
  // from the Provider Group Profile when no location is selected.
  serviceLocationAddress?: Address | null;
  renderingproviderId?: { [key: string]: string };
  priorAuthorization: string;
};

// export const PatientProcedureCodeDiscountTypeEnum = {
//     Percentage: 'PERCENTAGE',
//     Amount: 'AMOUNT'
// } as const;

type OptionDiscount = {
  value: PatientProcedureCodeDiscountTypeEnum;
  label: string;
};

export const PROCEDURE_CODE_DISCOUNT_TYPE: OptionDiscount[] = [
  {
    label: "Percentage",
    value: "PERCENTAGE",
  },
  {
    label: "Amount",
    value: "AMOUNT",
  },
];

type providerDetails = {
  billingProviderId?: { [key: string]: string };
  billingProvideNPINumber: string;
  referringProviderId?: { [key: string]: string };
  referringProviderNPINumber: string;
  orderingProviderId?: { [key: string]: string };
  orderingProviderNPINumber: string;
};
type diagnisisCodeData = {
  uuid: string;
  codeVersion: string;
  type: string;
  code: string;
  description: string;
  source: string;
  active: boolean;
  archive: boolean;
  errorMessage: string;
};
type diagnosisCodeSection = {
  diagnisisCodeData: diagnisisCodeData[] | undefined;
};
export type patientBalance = {
  subTotal?: string;
  advancedPaid?: string;
  insuranceAmount?: string;
  previousBalance?: string;
  total?: string;
};

export type AddSuperBillForm = ServiceDetails &
  providerDetails &
  diagnosisCodeSection &
  patientBalance;

export const ADD_SUPER_BILL_INITIAL_STATE: AddSuperBillForm = {
  uuid: "",

  // Service Details
  providerId: undefined,
  locationId: undefined,
  placeOfService: undefined,
  dateOfService: undefined,
  serviceState: undefined,
  serviceLocationAddress: undefined,
  renderingproviderId: undefined,
  priorAuthorization: "",

  // Provider Details
  billingProviderId: undefined,
  billingProvideNPINumber: "",
  referringProviderId: undefined,
  referringProviderNPINumber: "",
  orderingProviderId: undefined,
  orderingProviderNPINumber: "",

  // diagnioisCodeSection
  diagnisisCodeData: undefined,
};

// to do this for modifiers type check
// type Option = { [k: string]: string };
// type  OmitedModifiers = Exclude<,"modifiers">

export const ADD_SUPER_BILL_PROCEDURE_INITIAL_STATE: ProcedureCodeFormRow[] = [
  {
    uuid: undefined,
    procedureCode: undefined,
    diagnosisFirstPointers: "",
    diagnosisSecondPointers: "",
    diagnosisThirdPointers: "",
    diagnosisFourthPointers: "",
    medicalCodeModifiers: "",
    modifiers: undefined,
    quantity: 1,
    total: 0,
    charges: 0,
    discount: 0,
    discountType: undefined,
  },
];
